export default e => ({
  title: e.title,
  theater: e.theater,
  stageDirector: e.stageDirector,
  conductor: e.conductor,
  role: e.role,
  year: e.year,
});



// WEBPACK FOOTER //
// ./src/transforms/CleanWorkExperience.js